<template>
  <div style="padding-top:44px; padding-bottom:56px;">
    <div style="display: flex;
    flex-direction: column;
    justify-content: center;
   
    width:100%;
    
    align-items: center;">

   

    <mu-carousel hide-controls style="height:36vw;width: 100%;">
  <mu-carousel-item v-for="item in imagelist" :key="item">
    <img :src="item" style="width: 100%;height: auto;">
  </mu-carousel-item>
  
</mu-carousel>
    
      <van-notice-bar 
      style="width:100%"
      scrollable
      color='#ff0000'
  left-icon="volume-o"
  :text="gonggao"
/>   
     <!--
      <input  v-if="!user" class="myinput" type="text" placeholder="请输入手机号码" v-model="phone">

      <mu-button  v-if="!user" @click="toReg" color="primary" full-width>注册</mu-button>
      <span v-if="!user" class='loginclass'>已有账号？<a @click="toLogin">登录</a></span>
    -->
    </div>
    <div>
     
        
        <section class="markets" >
        
        <dl @click="toChart('hsbs')" >
          <img 
          />
          <dt>HSBS</dt>
          <dd growing-ignore="true" class="close up">{{this.$store.state.chuangxin['hsbs'].price.toFixed(2)}}</dd>
          <dd growing-ignore="true" class="rate up">{{this.$store.state.chuangxin['hsbs'].upradio|upradio}}%</dd>
        </dl>
        <dl @click="toChart('tesco')">
          <img
            
            
          />
          <dt>TESCO</dt>
          <dd growing-ignore="true" class="close up">{{this.$store.state.chuangxin['tesco'].price.toFixed(2)}}</dd>
          <dd growing-ignore="true" class="rate up">{{this.$store.state.chuangxin['tesco'].upradio|upradio}}%</dd>
        </dl>
        <dl @click="toChart('barclays')">
          <img
           
            
          />
          <dt>BARCLAYS</dt>
          <dd growing-ignore="true" class="close up">{{this.$store.state.chuangxin['barclays'].price.toFixed(2)}}</dd>
          <dd growing-ignore="true" class="rate up">{{this.$store.state.chuangxin['barclays'].upradio|upradio}}%</dd>
        </dl>
      </section> 

   
    <!--   <div   style="padding:10px;"><mu-button color='primary' @click="toCNC">一键充值</mu-button></div>
 -->
     
      <div style="text-align:left;padding:20px;" >{{this.$store.state.label2}}</div>
    
    
       <div style="padding:0px 10px 0px 10px;">
           <img :src="this.$store.state.image2url">
      </div>
 
    </div>
  </div>
</template>

<script>
export default {
  data(){
     return {
       phone:'',
        swiperOption: {
         loop:true,
         autoplay:true,
         observe:true,
         observeParents:true,
         observeSlideChildren:true,
         loopedSlides:6,
         slidePerView:'auto'
      },
     }
  },
  computed:{
      datalist(){
          let dt=this.$store.state.tickers.filter((item)=>{
             return item.symbol.indexOf('usdt')>2;
          })
          dt.sort((a,b)=>{
            return ((a.close-a.open)/a.open)-((b.close-b.open)/b.open)
          })
          return dt.slice(0,8);
      },
      gonggao(){
          return this.$store.state.gonggao;
      },
      user(){
        return this.$store.state.user;
      },
      imagelist(){
        return this.$store.state.imagelist;
      },
      product_lists(){
      
        
        return this.$store.state.product_lists;
      }
  },
  filters:{
    upradio(item) {
      return (item * 100).toFixed(2) + "%";
    },
  },
  methods:{
    
    toChart(symbol) {
     
      this.$router.push({
        name: "chart",
        params: {
          symbol: symbol,
          symbolName: symbol.toUpperCase()
        }
      });
    },
    
    toCNC(){
      
       this.$router.push("/one-trade")
    },
    toReg()
    {
      this.$router.push("/register")
    },
    toLogin()
    {
      this.$router.push("/login")
    }
  }
};
</script>

<style scoped>
.myinput {
   width: 100%;
    height: 40px;
    line-height: 1;
    font-size: 1rem;
    border-radius: 5px;
    border: none;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: Roboto,serif;
    text-align: left;
    margin-bottom: 20px;
    color:gray;
    outline:none;
}
.markets {
  display: flex;
  
  justify-content: space-evenly;
}
.markets img {
   width: 24vw;
}
.markets dt {
  font-family: bold;
}
.markets-rate {
  margin-top: 20px;
  background-color: #fff;
}
.markets-rate dd {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 0;
}
.upper .uppercase {
  font-style: normal;
  text-transform: uppercase;
}
.up {
  color:red;
  font-size: 1rem;
}
.down {
  font-size: 0.8rem;
  color:darkgrey;
}
.em{
    background-color: #03ad8f;
    padding: 10px;
    border-radius: 6px;
    margin: 5px;
    color:white;
}
.loginclass {
      font-weight: 700;
    width: 50%;
    margin-top: 30px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid hsla(0,0%,100%,.25);
    background-color: hsla(0,0%,100%,.06);
    line-height: 40px;
    text-align: center;
    color: red;
    padding: 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Index_hs.vue